<div class="feedback-button-container">
  <button
    type="button"
    pButton
    class="p-element p-button p-component"
    (click)="onButtonClick()"
  >
    <svg class="lightbulb-icon" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <!-- Top ray -->
      <line x1="50" y1="8" x2="50" y2="18" class="ray"/>
      <!-- Top-right ray -->
      <line x1="71" y1="15" x2="64" y2="22" class="ray"/>
      <!-- Right ray -->
      <line x1="85" y1="35" x2="75" y2="35" class="ray"/>
      <!-- Bottom-right ray -->
      <line x1="78" y1="55" x2="70" y2="48" class="ray"/>
      <!-- Bottom-left ray -->
      <line x1="22" y1="55" x2="30" y2="48" class="ray"/>
      <!-- Left ray -->
      <line x1="15" y1="35" x2="25" y2="35" class="ray"/>
      <!-- Top-left ray -->
      <line x1="29" y1="15" x2="36" y2="22" class="ray"/>
      
      <!-- Lightbulb body -->
      <path class="bulb" d="M 50 25 C 41 25 34 32 34 41 C 34 46 36 50 38 54 L 38 60 C 38 62 40 64 42 64 L 58 64 C 60 64 62 62 62 60 L 62 54 C 64 50 66 46 66 41 C 66 32 59 25 50 25 Z" fill="none"/>
      <!-- Bulb base -->
      <rect x="42" y="64" width="16" height="4" rx="1" class="base" fill="none"/>
      <rect x="42" y="68" width="16" height="4" rx="1" class="base" fill="none"/>
    </svg>
    <span>Share Feedback</span>
  </button>
</div>

<!-- Feedback Modal -->
<gs-share-feedback-modal
  [(visible)]="showFeedbackModal"
  (feedbackSubmitted)="onFeedbackSubmitted($event)"
></gs-share-feedback-modal>
